import { getPhoneLengthsByCountry as o } from "./getPhoneLengthsByCountry.mjs";
const i = (n, t) => {
  const { minLength: e } = o(t);
  return n.length >= e;
};
export {
  i as isPhoneMinimumLengthValid
};
//# sourceMappingURL=isPhoneLengthValid.mjs.map
